import onReady from '../utils/onReady';
import domIterator from '../utils/domIterator';
import queryStringParam from '../utils/queryStringParam';
import * as ClassList from '../utils/classList';

/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class SectionInfo {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    // Check the czech checkboxes
    checkBoxes() {
        domIterator(this.dom.checkboxes, element => {
            // Get name to check for, e.g. "Family" or "Youth". Taken from ID which is e.g. #homeYouth
            let checkforName = element.getAttribute("id").replace("home", "");

            if (queryStringParam(checkforName) != null) {
                element.checked = true;
                element.checked = "checked";

                this.params += "&" + checkforName;
            }
        });

        // Maintain the params given from searchPage, when switching between tabs
        domIterator(this.dom.naviHoriLinks, element => {
            element.href += this.params;
        });

        // If theres only one checkbox though, then just set it to checked, and move on with life
        if (this.dom.checkboxes.length == 1 && !this.dom.checkboxes[0].disabled) {
            this.dom.checkboxes[0].checked = true;
            this.dom.checkboxes[0].checked = "checked";
        }
    }

    // Add aria-current to identify the current page within a set of "tabs" links
    handleTabs() {
        domIterator(this.dom.naviHoriLinks, (element, idx) => {
            if (ClassList.contains(element.parentElement, "navigation-horizontal__list-item--active")) {
                element.setAttribute("aria-current", "page");
                element.focus();
            }

            // add URL fragment to the links
            if (idx > 0) {
                element.href += "#navihori";
            }
        });
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container"
            checkboxes: container.querySelectorAll(".leaseType__checkbox input"),
            naviHoriLinks: document.querySelectorAll(".navigation-horizontal__list-item a")
        };

        this.params = "";

        // Put your other DOM-specific initializations here, and get your class moving!

        this.checkBoxes();

        this.handleTabs();
    }

}


export default SectionInfo;